// @ts-nocheck
import { h } from "preact";
import { Modal } from "antd";
import { useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { Text } from "../../../../text";
import { TableData } from "../table/data";

export const ModalEdit = forwardRef((props, ref) => {
  const { item, columns, onCallbackEdit } = props;
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const { valueKey } = item;

  useImperativeHandle(ref, () => ({
    openModal(value) {
      setItems(value);
      setVisible(true);
    },
  }));

  function onChangeText(e, item, ref) {
    const findIndex = items.findIndex((el) => el[valueKey] === item[valueKey]);
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(items));
    d[findIndex][ref] = e.target.value;
    setItems(d);
  }

  function onOk() {
    onCallbackEdit(items);
    setVisible(false);
  }

  return (
    <Modal
      width={650}
      centered
      title={
        (<Text size={"XS"} text={`แก้ไขข้อมูล`} bold />) as React.ReactNode
      }
      transitionName={""}
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      onOk={onOk}
      onCancel={() => setVisible(false)}
    >
      <TableData columns={columns({ onChangeText })} data={items} />
    </Modal>
  );
});
